import {
  INSTANCE_EATD_OPTIONS_READ_META,
  INSTANCE_EATD_OPTIONS_UPDATE,
} from 'client/redux/eatd/constants';
// Import the action type from instance constants
import { INSTANCE_SETUP_UPDATE_SUCCESS } from 'client/redux/instance/constants'; 
import { reduceByTypes } from 'client/redux/apiHelpers';
import _ from 'lodash'; // Import lodash
  
const defaultState = {
  isReadingMeta: false,
  isUpdating: false,
  errorMeta: null,
  errorUpdate: null,
  meta: null,
  operatorAnonymizationEnabled: true, 
  inactiveDaysThreshold: 90,
  operatorRules: [],
  operatorDefaultChanges: [],
  incidentProcessingEnabled: false,
  incidentRules: [],
  incidentDefaultChanges: [],
  personProcessingEnabled: false,
  personRules: [],
  personDefaultChanges: [],
};
  
export default function optionsReducer (state = defaultState, action) {
  // Handle reading metadata
  state = reduceByTypes(INSTANCE_EATD_OPTIONS_READ_META, state, action, {
    requestProp: 'isReadingMeta',
    errorProp: 'errorMeta',
    successProp: 'meta',
  });
  
  // Handle updating options (specific EATD update endpoint, might not be used from setup form)
  state = reduceByTypes(INSTANCE_EATD_OPTIONS_UPDATE, state, action, {
    requestProp: 'isUpdating',
    errorProp: 'errorUpdate',
    // This assumes payload structure { options: { ... } }
    successHandler: (state, action) => ({
      ...state,
      isUpdating: false,
      errorUpdate: null,
      ...(_.get(action.payload, 'instance.settings') || _.get(action.payload, 'options', {})),
    }),
  });
  
  switch (action.type) {
    // Handle updates coming from the general instance setup save
    case INSTANCE_SETUP_UPDATE_SUCCESS: {
      const instanceSettings = _.get(action.payload, 'instance.settings');
      if (instanceSettings) {
        return {
          ...state,
          operatorAnonymizationEnabled: _.get(instanceSettings, 'operatorAnonymizationEnabled', state.operatorAnonymizationEnabled),
          inactiveDaysThreshold: _.get(instanceSettings, 'inactiveDaysThreshold', state.inactiveDaysThreshold),
          operatorRules: _.get(instanceSettings, 'operatorRules', state.operatorRules),
          operatorDefaultChanges: _.get(instanceSettings, 'operatorDefaultChanges', state.operatorDefaultChanges),
          incidentProcessingEnabled: _.get(instanceSettings, 'incidentProcessingEnabled', state.incidentProcessingEnabled),
          incidentRules: _.get(instanceSettings, 'incidentRules', state.incidentRules),
          incidentDefaultChanges: _.get(instanceSettings, 'incidentDefaultChanges', state.incidentDefaultChanges),
          personProcessingEnabled: _.get(instanceSettings, 'personProcessingEnabled', state.personProcessingEnabled),
          personRules: _.get(instanceSettings, 'personRules', state.personRules),
          personDefaultChanges: _.get(instanceSettings, 'personDefaultChanges', state.personDefaultChanges),
          isUpdating: false, 
          errorUpdate: null,
        };
      }
      return state; 
    }

    default: return state;
  }
}
